import common from './common/index'
import map from './map/index'
import business from './business/index'
import risk from './risk/index'
import enterprise from './enterprise/index'
import info from './infos/index'
import project from './project/index'
import personal from './personalCenter'
import topic from './topic/index'
import analysis from './analysis/index'
import exhibition from './exhibition/index'
import multilateralDynamics from './multilateralDynamics/index'

const pbrApis = () => {
  return {
    ...common,
    ...analysis,
    ...project,
    ...exhibition,
    ...info,
    ...enterprise,
    ...business,
    ...risk,
    ...map,
    ...personal,
    ...topic,
    ...multilateralDynamics
  }
}

export default {
  install (Vue) {
    Vue.prototype.$pbrApis = pbrApis()
  }
}
